<template>
  <div class="container">
    <NavMenu class="nav_menu"></NavMenu>
    <div class="content">
      <div class="chart-container">
        <div class="line-chart">
          <div class="line-chart-header">
            <div class="header-left" style="padding-left: 40px;">
              <el-date-picker
                v-model="selectedYear"
                type="year"
                placeholder="选择年份"
                @change="handleYearChange"
                style="width: 120px;"
                value-format="yyyy"
                :clearable="false"
              />
            </div>
          </div>
          <div ref="lineChart" style="width: 100%; height: 300px;"></div>
        </div>
        
        <div class="pie-chart">
          <h3>帖子类型分布</h3>
          <div ref="pieChart" style="width: 100%; height: 300px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue';
import * as echarts from 'echarts';

export default {
  components: { NavMenu },
  data() {
    return {
      selectedYear: new Date().getFullYear().toString(),
      lineChart: null,
      pieChart: null,
      postTypes: [
        { value: 335, name: '宠物生活' },
        { value: 310, name: '宠物问答' },
        { value: 234, name: '有趣知识' },
        { value: 135, name: '好物分享' }
      ],
      posts: [
        { id: 1, type: '宠物生活', createTime: '2025-01-15 10:20:30' },
        { id: 2, type: '宠物问答', createTime: '2025-01-20 11:30:45' },
        { id: 3, type: '有趣知识', createTime: '2025-02-05 09:15:22' },
        { id: 4, type: '好物分享', createTime: '2025-02-18 14:25:10' },
        { id: 5, type: '宠物生活', createTime: '2025-02-28 16:40:33' },
        { id: 6, type: '宠物问答', createTime: '2025-03-02 08:12:45' },
        { id: 7, type: '有趣知识', createTime: '2025-03-10 12:30:15' },
        { id: 8, type: '好物分享', createTime: '2025-03-20 11:08:20' },
        { id: 9, type: '宠物生活', createTime: '2025-04-05 13:45:30' },
        { id: 10, type: '宠物问答', createTime: '2025-04-12 10:20:40' },
        { id: 11, type: '有趣知识', createTime: '2025-05-01 09:30:25' },
        { id: 12, type: '好物分享', createTime: '2025-05-15 15:10:50' },
        { id: 13, type: '宠物生活', createTime: '2025-06-08 11:25:35' },
        { id: 14, type: '宠物问答', createTime: '2025-06-20 14:40:10' },
        { id: 15, type: '有趣知识', createTime: '2025-07-03 10:15:45' },
        { id: 16, type: '宠物生活', createTime: '2025-08-10 09:30:20' },
        { id: 17, type: '好物分享', createTime: '2025-08-25 16:20:30' },
        { id: 18, type: '宠物问答', createTime: '2025-09-05 11:45:15' },
        { id: 19, type: '有趣知识', createTime: '2025-09-18 13:10:40' },
        { id: 20, type: '宠物生活', createTime: '2025-10-22 10:30:25' },
        { id: 21, type: '好物分享', createTime: '2025-11-15 14:50:10' },
        { id: 22, type: '宠物问答', createTime: '2025-12-03 08:20:35' },
        { id: 23, type: '有趣知识', createTime: '2025-12-20 12:40:50' }
      ]
    };
  },
  mounted() {
    this.initPieChart();
    this.initLineChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.lineChart) {
      this.lineChart.dispose();
    }
    if (this.pieChart) {
      this.pieChart.dispose();
    }
  },
  methods: {
    handleYearChange(val) {
      if (val) {
        this.selectedYear = val;
        this.updateLineChart();
      }
    },
    handleResize() {
      if (this.lineChart) {
        this.lineChart.resize();
      }
      if (this.pieChart) {
        this.pieChart.resize();
      }
    },
    initPieChart() {
      const chartDom = this.$refs.pieChart;
      if (!chartDom) return;
      
      this.pieChart = echarts.init(chartDom);
      const option = {
        color: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          top: '5%',
          left: 'center',
          data: this.postTypes.map(item => item.name)
        },
        series: [
          {
            name: '帖子类型',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center',
              formatter: '{b}: {c} ({d}%)'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.postTypes
          }
        ]
      };
      this.pieChart.setOption(option);
    },
    initLineChart() {
      const chartDom = this.$refs.lineChart;
      if (!chartDom) return;
      
      this.lineChart = echarts.init(chartDom);
      this.updateLineChart();
    },
    updateLineChart() {
      if (!this.lineChart) return;
      
      const yearPosts = this.posts.filter(post => {
        return post.createTime.startsWith(this.selectedYear);
      });
      
      const monthlyCounts = Array(12).fill(0);
      yearPosts.forEach(post => {
        const month = parseInt(post.createTime.split('-')[1]) - 1;
        monthlyCounts[month]++;
      });
      
      const option = {
        grid: {
          left: '40px',
          right: '20px',
          top: '50px',
          bottom: '30px'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}<br/>发帖数量: {c}'
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#666'
          }
        },
        yAxis: {
          type: 'value',
          name: '发帖数量',
          nameTextStyle: {
            color: '#666',
            padding: [0, 0, 0, 40]
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            color: '#666'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#eee'
            }
          }
        },
        series: [
          {
            name: '发帖数量',
            data: monthlyCounts,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              color: '#409EFF'
            },
            itemStyle: {
              color: '#409EFF',
              borderColor: '#fff',
              borderWidth: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(64, 158, 255, 0.5)'
                },
                {
                  offset: 1,
                  color: 'rgba(64, 158, 255, 0.1)'
                }
              ])
            },
            label: {
              show: true,
              position: 'top',
              color: '#409EFF'
            }
          }
        ]
      };
      
      this.lineChart.setOption(option);
    }
  }
};
</script>

<style scoped>
/* 重置全局边距 */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}

.container {
  display: flex;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #f5f7fa;
  overflow: hidden; /* 禁止外层滚动 */
}

.nav_menu {
  width: 280px;
  flex: 0 0 auto;
  height: 100vh;
  position: sticky;
  top: 0;
  overflow-y: auto; /* 导航菜单独立滚动 */
}

.content {
  flex: 1;
  padding: 0;
  height: 100vh;
  overflow-y: auto; /* 内容区域独立滚动 */
}

.chart-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  min-height: calc(100% - 40px); /* 减去padding */
}

.pie-chart, .line-chart {
  width: 100%;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.line-chart-header {
  margin-bottom: 15px;
}

.header-left {
  display: flex;
  align-items: center;
}

h3 {
  margin: 0 0 0 10px;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
</style>